// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"ProductCount_wrapper__qT_8W","icon":"ProductCount_icon__fixjg"};